import type { ReactNode } from 'react'

export type SortOrder = 'ascend' | 'descend' | null

export interface ColumnType<T> {
  title?: ReactNode
  dataIndex?: string
  key?: string
  sorter?: boolean
  align?: 'left' | 'center' | 'right'
  width?: number | string
  concealable?: boolean
  render?: (value: any, record: T, index: number) => ReactNode
}

export type ColumnsType<T> = ColumnType<T>[]


export type PageReadPayload = {
  page: number
  size: number
  sort?: string | null
  q?: string | null
}

export type PageRead<T> = {
  results: T[]
  count: number
  offset: number
  limit: number
}

export enum PageReadKey {
  Current = 'current',
  Count = 'count',
  Offset = 'offset',
  Limit = 'limit',
  Sort = 'sort',
  Search = 'q'
}
